import { store } from 'redux/store';

import downloadWord from 'utils/downloadWord';
import previewDownload from 'utils/previewDownload';

import { setModal } from 'modules/_shared/redux/modalActions';
import boardTemplateTypes from 'modules/boards/constants/boardTemplateTypes';
import ReplaceBoardTemplate from 'modules/boards/modals/ReplaceBoardTemplate';
import ReplaceTemplateWithDocumentModal from 'modules/boards/modals/ReplaceTemplateWithDocumentModal';

function menuOptions(i18n) {
  return [
    {
      icon: 'ni-file-pdf',
      text: i18n.t('DownloadPDF'),
      action: previewDownload,
      disabled: ({ isDocumentFile }) => !!isDocumentFile,
    },
    {
      icon: 'ni-file-doc',
      text: i18n.t('DownloadWord'),
      action: ({ preview }) =>
        downloadWord(preview.documentModel, preview.name),
      disabled: ({ isDocumentFile }) => !!isDocumentFile,
    },
    {
      icon: 'ni-edit',
      text: i18n.t('Edit'),
      action: ({ setShowEditor }) => setShowEditor(true),
      disabled: ({ isDocumentFile }) => !!isDocumentFile,
    },
    {
      icon: 'ni-files',
      text: i18n.t('ChangeTemplate'),
      action: ({ board }) =>
        store.dispatch(
          setModal(
            <ReplaceBoardTemplate
              board={board}
              templateType={boardTemplateTypes.CERTIFICATION}
            />
          )
        ),
      disabled: ({ isDocumentFile }) => !!isDocumentFile,
    },
    {
      id: 'replace-act',
      icon: 'ni-upload',
      text: i18n.t('ReplaceCertificate'),
      action: ({ board }) => {
        store.dispatch(
          setModal(
            <ReplaceTemplateWithDocumentModal
              boardId={board._id}
              templateType={boardTemplateTypes.CERTIFICATION}
            />
          )
        );
      },
      disabled: false,
    },
    {
      id: 'replace-act',
      icon: 'ni-upload',
      text: i18n.t('ReplaceCertificate'),
      action: ({ board }) => {
        store.dispatch(
          setModal(
            <ReplaceTemplateWithDocumentModal
              boardId={board._id}
              templateType={boardTemplateTypes.CERTIFICATION}
            />
          )
        );
      },
      disabled: false,
    },
  ];
}
export default menuOptions;
